import { ProcessProjectForChangeDto } from '@codefluegel/zeta-change-typescript-client';
import { Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

const ProcessAccordionTitle = observer(
  ({ department }: { department: ProcessProjectForChangeDto }) => (
    <Stack
      spacing={0}
      sx={{
        flexShrink: 0,
        justifySelf: 'flex-start',
        height: 'max-content',
        marginRight: '20px',
        maxWidth: '230px',
        width: '230px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        alignSelf: 'center',
      }}
    >
      <Typography variant="h4" sx={{ lineHeight: 2 }}>
        {`${department?.groupNo ?? ''} ${department?.name ?? ''}`}
      </Typography>
      {department?.mandant && (
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: '0.875rem',
            marginTop: '-5px',
          }}
        >
          {department?.mandant ?? ''}
        </Typography>
      )}
    </Stack>
  ),
);

export default ProcessAccordionTitle;
